// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore";

const name = "pbrBlockDirectLighting";
const shader = `vec3 diffuseBase=vec3(0.,0.,0.);#ifdef SPECULARTERM
vec3 specularBase=vec3(0.,0.,0.);#endif
#ifdef CLEARCOAT
vec3 clearCoatBase=vec3(0.,0.,0.);#endif
#ifdef SHEEN
vec3 sheenBase=vec3(0.,0.,0.);#endif
preLightingInfo preInfo;lightingInfo info;float shadow=1.; #if defined(CLEARCOAT) && defined(CLEARCOAT_TINT)
vec3 absorption=vec3(0.);#endif
`;
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @internal */
export const pbrBlockDirectLighting = { name, shader };
